export default $axios => ({
    getBrands() {
        return $axios({
            method: 'GET',
            url: `/general/brand/`
        });
    },
    getBrandBySlug(slug, params) {
        return $axios(
            {
                method: 'GET',
                url: `/general/brand/${slug}`,
                params: params
            },
            {
                redirectOnError: true
            }
        );
    }
});
